import { gql } from '@apollo/client'

export const PROCESSINGS_EVALUATION_QUERY = gql`
  query processingsEvaluation($filter: ProcessingsEvaluationFilter) {
    processingsEvaluation(filter: $filter) {
      series {
        name
        openProcessings
        legalProcessingsSum
        legalProcessingsResolvedByLegalAdvisor
        legalProcessingsReferredToM2Med
        legalProcessingsReferredToM2Zmb
        legalProcessingsReferredToM2Gv
        legalProcessingsReferredAttorneyArag
        legalProcessingsReferredAttorneyAuxilia
        legalProcessingsReferredAttorneyAllianz
        legalProcessingsToRightmartAuxilia
        clickPathProcessingsSum
        clickPathProcessingsResolvedByLegalAdvisor
        clickPathProcessingsReferredToM2Med
        clickPathProcessingsReferredToM2Zmb
        clickPathProcessingsReferredToM2Gv
        clickPathProcessingsReferredAttorneyArag
        clickPathProcessingsReferredAttorneyAuxilia
        clickPathProcessingsReferredAttorneyAllianz
        clickPathProcessingsToRightmartAuxilia
        serviceProcessings
      }
    }
  }
`
